import { useNavigate } from "react-router-dom";
import ConsultingHero from "../shared/ConsultingHero/ConsultingHero";
import ServiceIntro from "../shared/ServiceIntro/ServiceIntro";
import ImageContentSection from "../shared/ImageContentSection/ImageContentSection";
import ServiceCardsSection from "../shared/ServiceCardsSection/ServiceCardsSection";
import ProcessDiagram from "../shared/ProcessDiagram/ProcessDiagram";
import CTABanner from "../shared/CTABanner/CTABanner";
import AssociatedServices from "../shared/AssociatedServices/AssociatedServices";
import { corporateSponsorshipWhyItWorks, corporateSponsorshipHowWeHelp, corporateSponsorshipAssociatedServices } from "./data/consultingData";

const CorporateSponsorshipService = () => {
  const navigate = useNavigate();

  return (
    <div>
      <ConsultingHero 
        title="Secure Corporate Sponsorships"
        buttonText="Book a Sponsorship Strategy Call" 
        bgColor="bg-gradient-to-b from-blue-gradientBlue1 to-blue-gradientBlue2" 
        imageSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/doberman-480.webp" 
        imageSrcSet="
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/doberman-480.webp 480w, 
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/doberman-1280.webp 1280w, 
          https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/doberman-1920.webp 1920w" 
        imageAlt="A doberman" 
        imageClassName="md:translate-x-20 xl:translate-x-60"
         />
      <ServiceIntro
        title="Experts in helping nonprofits grow through corporate sponsorships"
        description="We help you turn corporate social responsibility budgets into predictable funding for the animals you serve. Our team researches, connects, and closes purpose-driven companies on your behalf—so you can focus on your mission."
        rightCircleSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/right-circles-blue.svg"
      />
      <ImageContentSection
        imagePosition="left"
        imageSrc={corporateSponsorshipWhyItWorks.imageSrc}
        imageAlt={corporateSponsorshipWhyItWorks.imageAlt}
        title={corporateSponsorshipWhyItWorks.title}
        description={corporateSponsorshipWhyItWorks.description}
        items={corporateSponsorshipWhyItWorks.items}
        imageClassName="object-fill"
      />
      <ServiceCardsSection
        bgColor={corporateSponsorshipHowWeHelp.bgColor}
        title={corporateSponsorshipHowWeHelp.title}
        titleColor={corporateSponsorshipHowWeHelp.titleColor}
        accentColor={corporateSponsorshipHowWeHelp.accentColor}
        description={corporateSponsorshipHowWeHelp.description}
        cardBg={corporateSponsorshipHowWeHelp.cardBg}
        items={corporateSponsorshipHowWeHelp.items}
      />
      <ProcessDiagram
        title="The sponsorship system in action"
        description="We don't just give you ideas — we equip your team with the tools, assets, and strategy needed to build lasting corporate partnerships. Here's how each piece of our process works together to help you reach, engage, and retain the right sponsors."
        svgSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/timeline1.svg"
        svgAlt="Corporate sponsorship process diagram"
      />
      <CTABanner
        bgColor="bg-orange-dark1"
        overlayFrom="from-orange-dark1 via-orange-dark1/80"
        imageSrc="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/lab3.webp"
        imageAlt="A labrador puppy"
        title="Getting Started"
        description="Start Partnering with More Brands, Sponsors, and Corporate Allies"
        buttonText="Get Started"
        buttonTo="/contact-us"
        imageClassName="md:object-[center_10%] xl:object-[center_20%] md:translate-x-10"
      />
      <AssociatedServices
        subtitle="More ways to grow your audience."
        services={corporateSponsorshipAssociatedServices}
        cols={2}
      />
    </div>
  );
};

export default CorporateSponsorshipService;
